<template>
  <div class="dashboard-editor-container">
<div class="userStatistics">
  <h2>用户统计</h2>
    <el-row :gutter="40" class="panel-group">
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel" @click="handleSetLineChartData('newVisitis')">
        <div class="card-panel-icon-wrapper icon-people">
          <svg-icon icon-class="peoples" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
           当天登入人数
          </div>
          <!-- <count-to :start-val="0" :end-val="getInfo.loginUserCount" :duration="2600" class="card-panel-num" /> -->
          <span class="numbers">{{getInfo.loginUserCount}}</span>
        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel" @click="handleSetLineChartData('newVisitis')">
        <div class="card-panel-icon-wrapper icon-people">
          <svg-icon icon-class="peoples" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
           用户总数
          </div>
          <!-- <count-to :start-val="0" :end-val="getInfo.userTotalCount" :duration="2600" class="card-panel-num" /> -->
          <span class="numbers">{{getInfo.userTotalCount}}</span>

        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel" @click="handleSetLineChartData('newVisitis')">
        <div class="card-panel-icon-wrapper icon-people">
          <svg-icon icon-class="peoples" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
           当日新注册用户数
          </div>
          <!-- <count-to :start-val="0" :end-val="getInfo.todayRegisterUserCount" :duration="2600" class="card-panel-num" /> -->
          <span class="numbers">{{getInfo.todayRegisterUserCount}}</span>

        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel" @click="handleSetLineChartData('newVisitis')">
        <div class="card-panel-icon-wrapper icon-people">
          <svg-icon icon-class="peoples" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
           用户资金余额
          </div>
          <!-- <count-to :start-val="0" :end-val="getInfo.userAssetsTotalBalance" :duration="2600" class="card-panel-num" /> -->
          <span class="numbers">{{getInfo.userAssetsTotalBalance}}</span>

        </div>
      </div>
    </el-col>


  </el-row>
</div>
<div class="userStatistics">
  <h2>资金统计</h2>
    <el-row :gutter="40" class="panel-group">

      <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel" @click="handleSetLineChartData('purchases')">
        <div class="card-panel-icon-wrapper icon-money">
          <svg-icon icon-class="money" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            今日充值
          </div>
          <!-- <count-to :start-val="0" :end-val="getInfo.todayRechargeTotalAmount" :duration="3200" class="card-panel-num" /> -->
          <span class="numbers">{{getInfo.todayRechargeTotalAmount}}</span>

        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel" @click="handleSetLineChartData('purchases')">
        <div class="card-panel-icon-wrapper icon-money">
          <svg-icon icon-class="money" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            今日提现
          </div>
          <!-- <count-to :start-val="0" :end-val="getInfo.todayWithdrawTotalAmount" :duration="3200" class="card-panel-num" /> -->
          <span class="numbers">{{getInfo.todayWithdrawTotalAmount}}</span>

        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel" @click="handleSetLineChartData('purchases')">
        <div class="card-panel-icon-wrapper icon-money">
          <svg-icon icon-class="money" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            收益总额
          </div>
          <!-- <count-to :start-val="0" :end-val="getInfo.incomeTotalAmount" :duration="3200" class="card-panel-num" /> -->
          <span class="numbers">{{getInfo.incomeTotalAmount}}</span>

        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel" @click="handleSetLineChartData('purchases')">
        <div class="card-panel-icon-wrapper icon-money">
          <svg-icon icon-class="money" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            投资总额
          </div>
          <!-- <count-to :start-val="0" :end-val="getInfo.investTotalAmount" :duration="3200" class="card-panel-num" /> -->
          <span class="numbers">{{getInfo.investTotalAmount}}</span>

        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel" @click="handleSetLineChartData('purchases')">
        <div class="card-panel-icon-wrapper icon-money">
          <svg-icon icon-class="money" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            充值总额
          </div>
          <!-- <count-to :start-val="0" :end-val="getInfo.rechargeTotalAmount" :duration="3200" class="card-panel-num" /> -->
          <span class="numbers">{{getInfo.rechargeTotalAmount}}</span>

        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel" @click="handleSetLineChartData('purchases')">
        <div class="card-panel-icon-wrapper icon-money">
          <svg-icon icon-class="money" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            提现总额
          </div>
          <!-- <count-to :start-val="0" :end-val="getInfo.withdrawTotalAmount" :duration="3200" class="card-panel-num" /> -->
          <span class="numbers">{{getInfo.withdrawTotalAmount}}</span>

        </div>
      </div>
    </el-col>


  </el-row>
</div>
<div class="userStatistics">
  <h2>利润统计</h2>
    <el-row :gutter="40" class="panel-group">
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel" @click="handleSetLineChartData('shoppings')">
        <div class="card-panel-icon-wrapper icon-shopping">
          <svg-icon icon-class="shopping" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            总利润
          </div>
          <!-- <count-to :start-val="0" :end-val="getInfo.totalProfitAmount" :duration="3600" class="card-panel-num" /> -->
          <span class="numbers">{{getInfo.totalProfitAmount}}</span>

        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel" @click="handleSetLineChartData('shoppings')">
        <div class="card-panel-icon-wrapper icon-shopping">
          <svg-icon icon-class="shopping" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            平台利润
          </div>

          <!-- <count-to :start-val="0" :end-val="getInfo.platformProfitAmount" :duration="3600" class="card-panel-num" /> -->
          <span class="numbers">{{getInfo.platformProfitAmount}}</span>

        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel" @click="handleSetLineChartData('shoppings')">
        <div class="card-panel-icon-wrapper icon-shopping">
          <svg-icon icon-class="shopping" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            充值人数
          </div>
          <!-- <count-to :start-val="0" :end-val="getInfo.rechargeUserCount" :duration="3600" class="card-panel-num" /> -->
          <span class="numbers">{{getInfo.rechargeUserCount}}</span>

        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel" @click="handleSetLineChartData('shoppings')">
        <div class="card-panel-icon-wrapper icon-shopping">
          <svg-icon icon-class="shopping" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            昨日新增
          </div>
          <!-- <count-to :start-val="0" :end-val="getInfo.yesterdayNewUserCount" :duration="3600" class="card-panel-num" /> -->
          <span class="numbers">{{getInfo.yesterdayNewUserCount}}</span>

        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel" @click="handleSetLineChartData('shoppings')">
        <div class="card-panel-icon-wrapper icon-shopping">
          <svg-icon icon-class="shopping" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            今日新增
          </div>

          <!-- <count-to :start-val="0" :end-val="getInfo.todayNewUserCount" :duration="3600" class="card-panel-num" /> -->
          <span class="numbers">{{getInfo.todayNewUserCount}}</span>

        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel" @click="handleSetLineChartData('shoppings')">
        <div class="card-panel-icon-wrapper icon-shopping">
          <svg-icon icon-class="shopping" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            提现手续费
          </div>
          <!-- <count-to :start-val="0" :end-val="getInfo.withdrawFeeAmount" :duration="3600" class="card-panel-num" /> -->
          <span class="numbers">{{getInfo.withdrawFeeAmount}}</span>

        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel" @click="handleSetLineChartData('shoppings')">
        <div class="card-panel-icon-wrapper icon-shopping">
          <svg-icon icon-class="shopping" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            充值手续费
          </div>
          <!-- <count-to :start-val="0" :end-val="getInfo.rechargeFeeAmount" :duration="3600" class="card-panel-num" /> -->
          <span class="numbers">{{getInfo.rechargeFeeAmount}}</span>

        </div>
      </div>
    </el-col>
  </el-row>
</div>


  </div>
</template>

<script>
import CountTo from 'vue-count-to'
import { get, post } from "@/utils/request";


export default {
  name: 'DashboardAdmin',
  components: {
    CountTo
  },
  data() {
    return {
      getInfo:{}
    }
  },
  created(){
this.getInfoList()
  },
  methods: {
    getInfoList(){
      get("/admin/data/dashboard").then((res) => {
        this.getInfo = res.data
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard-editor-container {
  padding: 32px;
  background-color: rgb(240, 242, 245);
  position: relative;

  .github-corner {
    position: absolute;
    top: 0px;
    border: 0;
    right: 0;
  }

  .chart-wrapper {
    background: #fff;
    padding: 16px 16px 0;
    margin-bottom: 32px;
  }
}

@media (max-width: 1024px) {
  .chart-wrapper {
    padding: 8px;
  }
}
.panel-group {
  margin-top: 18px;

  .card-panel-col {
    margin-bottom: 32px;
  }

  .card-panel {
    height: 108px;
    cursor: pointer;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, .05);
    border-color: rgba(0, 0, 0, .05);

    &:hover {
      .card-panel-icon-wrapper {
        color: #fff;
      }

      .icon-people {
        background: #40c9c6;
      }

      .icon-message {
        background: #36a3f7;
      }

      .icon-money {
        background: #f4516c;
      }

      .icon-shopping {
        background: #34bfa3
      }
    }

    .icon-people {
      color: #40c9c6;
    }

    .icon-message {
      color: #36a3f7;
    }

    .icon-money {
      color: #f4516c;
    }

    .icon-shopping {
      color: #34bfa3
    }

    .card-panel-icon-wrapper {
      float: left;
      margin: 14px 0 0 14px;
      padding: 16px;
      transition: all 0.38s ease-out;
      border-radius: 6px;
    }

    .card-panel-icon {
      float: left;
      font-size: 48px;
    }

    .card-panel-description {
      float: right;
      font-weight: bold;
      margin: 26px;
      margin-left: 0px;

      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-bottom: 12px;
      }

      .card-panel-num {
        font-size: 20px;
      }
    }
  }
}

@media (max-width:550px) {
  .card-panel-description {
    display: none;
  }

  .card-panel-icon-wrapper {
    float: none !important;
    width: 100%;
    height: 100%;
    margin: 0 !important;

    .svg-icon {
      display: block;
      margin: 14px auto !important;
      float: none !important;
    }
  }
}
.numbers{
  font-size: 20px;
}
</style>
